import Vue from "vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VueQuillEditor, { Quill } from "vue-quill-editor";
import TableHandler, { rewirteFormats } from "quill1.3.7-table-module";
import App from "./App.vue";
import router from "./router";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill1.3.7-table-module/dist/index.css";
import "./assets/theme.css";

window.Quill = Quill;
require("quill-image-resize-module");

Quill.register({ [`modules/${TableHandler.moduleName}`]: TableHandler }, true);
rewirteFormats();

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueQuillEditor);

new Vue({
  router,
  render: function render(createElement) {
    return createElement(App);
  }
}).$mount("#app");
